import { render, staticRenderFns } from "./HuntingPlace.vue?vue&type=template&id=661a5b38&"
import script from "./HuntingPlace.vue?vue&type=script&lang=ts&"
export * from "./HuntingPlace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports